module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "amazon-region-connect"
  }, [(_vm.showNickname) ? _c('div', {
    staticClass: "sk-field sk-seller-nickname"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accName),
      expression: "accName"
    }],
    attrs: {
      "id": "seller-account-nickname",
      "type": "text",
      "placeholder": "e.g. US main account",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.accName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accName = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showPricingMessage && _vm.$root.newPricingMessage) ? _c('p', {
    staticClass: "sk-pricing-note"
  }, [_vm._v("\n    Introducing New Daily ASIN tracking! "), _c('strong', [_vm._v(_vm._s(_vm.$root.newPricingMessage))])]) : _vm._e(), _vm._v(" "), (_vm.errorMsg) ? _c('div', {
    staticClass: "sk-error-msg",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.errorMsg))]) : _vm._e(), _vm._v(" "), (_vm.showIntro) ? _c('div', {
    staticClass: "sk-connect-intro"
  }, [_c('h3', [_vm._v("How it works")]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sk-region-grid"
  }, [_c('div', {
    staticClass: "sk-region-card",
    class: {
      'is-busy': _vm.connectingRegion === 'NA'
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "sk-mkt-chips",
    attrs: {
      "role": "group",
      "aria-label": "Americas marketplace"
    }
  }, [_c('button', {
    staticClass: "sk-mkt-chip sk-mkt-chip-all",
    class: {
      'is-selected': _vm.isMarketplaceSelected('NA', _vm.allMarketplacesSelection)
    },
    attrs: {
      "type": "button",
      "data-region": "NA",
      "data-marketplace-id": _vm.allMarketplacesSelection,
      "title": "All Americas marketplaces",
      "aria-pressed": _vm.isMarketplaceSelected('NA', _vm.allMarketplacesSelection) ? 'true' : 'false',
      "disabled": _vm.connectingRegion !== null
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('NA', _vm.allMarketplacesSelection)
      },
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('NA', _vm.allMarketplacesSelection)
      }
    }
  }, [_vm._v("\n          All\n        ")]), _vm._v(" "), _vm._l((_vm.naMarketplaces), function(opt) {
    return _c('button', {
      key: opt.marketplaceId,
      staticClass: "sk-mkt-chip",
      class: {
        'is-selected': _vm.isMarketplaceSelected('NA', opt.marketplaceId)
      },
      attrs: {
        "type": "button",
        "data-region": "NA",
        "data-marketplace-id": opt.marketplaceId,
        "title": opt.label,
        "aria-pressed": _vm.isMarketplaceSelected('NA', opt.marketplaceId) ? 'true' : 'false',
        "disabled": _vm.connectingRegion !== null
      },
      on: {
        "mousedown": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.selectMarketplace('NA', opt.marketplaceId)
        },
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.selectMarketplace('NA', opt.marketplaceId)
        }
      }
    }, [_vm._v("\n          " + _vm._s(opt.code) + "\n        ")])
  })], 2), _vm._v(" "), (_vm.selectedMarketplaceLabel('NA')) ? _c('p', {
    staticClass: "sk-region-selected-hint"
  }, [_vm._v("\n        Selected: " + _vm._s(_vm.selectedMarketplaceLabel('NA')) + " — then click Authorize →\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sk-region-card-actions"
  }, [_c('button', {
    staticClass: "sk-region-authorize",
    attrs: {
      "type": "button",
      "disabled": _vm.connectingRegion !== null
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.connectRegion('NA', _vm.selectedMarketplaceNa)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.connectingRegion === 'NA' ? 'Opening Amazon…' : 'Authorize →') + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-card",
    class: {
      'is-busy': _vm.connectingRegion === 'EU'
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "sk-mkt-chips",
    attrs: {
      "role": "group",
      "aria-label": "Europe marketplace"
    }
  }, [_c('button', {
    staticClass: "sk-mkt-chip sk-mkt-chip-all",
    class: {
      'is-selected': _vm.isMarketplaceSelected('EU', _vm.allMarketplacesSelection)
    },
    attrs: {
      "type": "button",
      "data-region": "EU",
      "data-marketplace-id": _vm.allMarketplacesSelection,
      "title": "All Europe marketplaces",
      "aria-pressed": _vm.isMarketplaceSelected('EU', _vm.allMarketplacesSelection) ? 'true' : 'false',
      "disabled": _vm.connectingRegion !== null
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('EU', _vm.allMarketplacesSelection)
      },
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('EU', _vm.allMarketplacesSelection)
      }
    }
  }, [_vm._v("\n          All\n        ")]), _vm._v(" "), _vm._l((_vm.euMarketplaces), function(opt) {
    return _c('button', {
      key: opt.marketplaceId,
      staticClass: "sk-mkt-chip",
      class: {
        'is-selected': _vm.isMarketplaceSelected('EU', opt.marketplaceId)
      },
      attrs: {
        "type": "button",
        "data-region": "EU",
        "data-marketplace-id": opt.marketplaceId,
        "title": opt.label,
        "aria-pressed": _vm.isMarketplaceSelected('EU', opt.marketplaceId) ? 'true' : 'false',
        "disabled": _vm.connectingRegion !== null
      },
      on: {
        "mousedown": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.selectMarketplace('EU', opt.marketplaceId)
        },
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.selectMarketplace('EU', opt.marketplaceId)
        }
      }
    }, [_vm._v("\n          " + _vm._s(opt.code) + "\n        ")])
  })], 2), _vm._v(" "), (_vm.selectedMarketplaceLabel('EU')) ? _c('p', {
    staticClass: "sk-region-selected-hint"
  }, [_vm._v("\n        Selected: " + _vm._s(_vm.selectedMarketplaceLabel('EU')) + " — then click Authorize →\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sk-region-card-actions"
  }, [_c('button', {
    staticClass: "sk-region-authorize",
    attrs: {
      "type": "button",
      "disabled": _vm.connectingRegion !== null
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.connectRegion('EU', _vm.selectedMarketplaceEu)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.connectingRegion === 'EU' ? 'Opening Amazon…' : 'Authorize →') + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-card",
    class: {
      'is-busy': _vm.connectingRegion === 'ME'
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "sk-mkt-chips",
    attrs: {
      "role": "group",
      "aria-label": "Middle East marketplace"
    }
  }, [_c('button', {
    staticClass: "sk-mkt-chip sk-mkt-chip-all",
    class: {
      'is-selected': _vm.isMarketplaceSelected('ME', _vm.allMarketplacesSelection)
    },
    attrs: {
      "type": "button",
      "data-region": "ME",
      "data-marketplace-id": _vm.allMarketplacesSelection,
      "title": "All Middle East marketplaces",
      "aria-pressed": _vm.isMarketplaceSelected('ME', _vm.allMarketplacesSelection) ? 'true' : 'false',
      "disabled": _vm.connectingRegion !== null
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('ME', _vm.allMarketplacesSelection)
      },
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('ME', _vm.allMarketplacesSelection)
      }
    }
  }, [_vm._v("\n          All\n        ")]), _vm._v(" "), _vm._l((_vm.meMarketplaces), function(opt) {
    return _c('button', {
      key: opt.marketplaceId,
      staticClass: "sk-mkt-chip",
      class: {
        'is-selected': _vm.isMarketplaceSelected('ME', opt.marketplaceId)
      },
      attrs: {
        "type": "button",
        "data-region": "ME",
        "data-marketplace-id": opt.marketplaceId,
        "title": opt.label,
        "aria-pressed": _vm.isMarketplaceSelected('ME', opt.marketplaceId) ? 'true' : 'false',
        "disabled": _vm.connectingRegion !== null
      },
      on: {
        "mousedown": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.selectMarketplace('ME', opt.marketplaceId)
        },
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.selectMarketplace('ME', opt.marketplaceId)
        }
      }
    }, [_vm._v("\n          " + _vm._s(opt.code) + "\n        ")])
  })], 2), _vm._v(" "), (_vm.selectedMarketplaceLabel('ME')) ? _c('p', {
    staticClass: "sk-region-selected-hint"
  }, [_vm._v("\n        Selected: " + _vm._s(_vm.selectedMarketplaceLabel('ME')) + " — then click Authorize →\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sk-region-card-actions"
  }, [_c('button', {
    staticClass: "sk-region-authorize",
    attrs: {
      "type": "button",
      "disabled": _vm.connectingRegion !== null
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.connectRegion('ME', _vm.selectedMarketplaceMe)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.connectingRegion === 'ME' ? 'Opening Amazon…' : 'Authorize →') + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-card",
    class: {
      'is-busy': _vm.connectingRegion === 'IN'
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "sk-mkt-chips sk-mkt-chips--solo",
    attrs: {
      "role": "group",
      "aria-label": "India marketplace"
    }
  }, [_c('button', {
    staticClass: "sk-mkt-chip sk-mkt-chip-all",
    class: {
      'is-selected': _vm.isMarketplaceSelected('IN', _vm.allMarketplacesSelection)
    },
    attrs: {
      "type": "button",
      "data-region": "IN",
      "data-marketplace-id": _vm.allMarketplacesSelection,
      "title": "India marketplace",
      "aria-pressed": _vm.isMarketplaceSelected('IN', _vm.allMarketplacesSelection) ? 'true' : 'false',
      "disabled": _vm.connectingRegion !== null
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('IN', _vm.allMarketplacesSelection)
      },
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('IN', _vm.allMarketplacesSelection)
      }
    }
  }, [_vm._v("\n          All\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "sk-mkt-chip",
    class: {
      'is-selected': _vm.isMarketplaceSelected('IN', _vm.inMarketplaces[0].marketplaceId)
    },
    attrs: {
      "type": "button",
      "data-region": "IN",
      "data-marketplace-id": _vm.inMarketplaces[0].marketplaceId,
      "title": "India",
      "aria-pressed": _vm.isMarketplaceSelected('IN', _vm.inMarketplaces[0].marketplaceId) ? 'true' : 'false',
      "disabled": _vm.connectingRegion !== null
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('IN', _vm.inMarketplaces[0].marketplaceId)
      },
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('IN', _vm.inMarketplaces[0].marketplaceId)
      }
    }
  }, [_vm._v("\n          IN\n        ")])]), _vm._v(" "), (_vm.selectedMarketplaceLabel('IN')) ? _c('p', {
    staticClass: "sk-region-selected-hint"
  }, [_vm._v("\n        Selected: " + _vm._s(_vm.selectedMarketplaceLabel('IN')) + " — then click Authorize →\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sk-region-card-actions sk-region-card-actions--tight"
  }, [_c('button', {
    staticClass: "sk-region-authorize",
    attrs: {
      "type": "button",
      "disabled": _vm.connectingRegion !== null
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.connectRegion('IN', _vm.selectedMarketplaceIn)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.connectingRegion === 'IN' ? 'Opening Amazon…' : 'Authorize →') + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-card",
    class: {
      'is-busy': _vm.connectingRegion === 'FE'
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "sk-mkt-chips",
    attrs: {
      "role": "group",
      "aria-label": "Asia Pacific marketplace"
    }
  }, [_c('button', {
    staticClass: "sk-mkt-chip sk-mkt-chip-all",
    class: {
      'is-selected': _vm.isMarketplaceSelected('FE', _vm.allMarketplacesSelection)
    },
    attrs: {
      "type": "button",
      "data-region": "FE",
      "data-marketplace-id": _vm.allMarketplacesSelection,
      "title": "All Asia Pacific marketplaces",
      "aria-pressed": _vm.isMarketplaceSelected('FE', _vm.allMarketplacesSelection) ? 'true' : 'false',
      "disabled": _vm.connectingRegion !== null
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('FE', _vm.allMarketplacesSelection)
      },
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.selectMarketplace('FE', _vm.allMarketplacesSelection)
      }
    }
  }, [_vm._v("\n          All\n        ")]), _vm._v(" "), _vm._l((_vm.feMarketplaces), function(opt) {
    return _c('button', {
      key: opt.marketplaceId,
      staticClass: "sk-mkt-chip",
      class: {
        'is-selected': _vm.isMarketplaceSelected('FE', opt.marketplaceId)
      },
      attrs: {
        "type": "button",
        "data-region": "FE",
        "data-marketplace-id": opt.marketplaceId,
        "title": opt.label,
        "aria-pressed": _vm.isMarketplaceSelected('FE', opt.marketplaceId) ? 'true' : 'false',
        "disabled": _vm.connectingRegion !== null
      },
      on: {
        "mousedown": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.selectMarketplace('FE', opt.marketplaceId)
        },
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.selectMarketplace('FE', opt.marketplaceId)
        }
      }
    }, [_vm._v("\n          " + _vm._s(opt.code) + "\n        ")])
  })], 2), _vm._v(" "), (_vm.selectedMarketplaceLabel('FE')) ? _c('p', {
    staticClass: "sk-region-selected-hint"
  }, [_vm._v("\n        Selected: " + _vm._s(_vm.selectedMarketplaceLabel('FE')) + " — then click Authorize →\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sk-region-card-actions"
  }, [_c('button', {
    staticClass: "sk-region-authorize",
    attrs: {
      "type": "button",
      "disabled": _vm.connectingRegion !== null
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.connectRegion('FE', _vm.selectedMarketplaceFe)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.connectingRegion === 'FE' ? 'Opening Amazon…' : 'Authorize →') + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "seller-account-nickname"
    }
  }, [_vm._v("Storefront nickname "), _c('span', {
    staticClass: "sk-optional"
  }, [_vm._v("(optional)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Pick a marketplace (or "), _c('strong', [_vm._v("All")]), _vm._v(" for every country in that region), then authorize. Amazon opens a secure page; once you approve, SentryKit loads your store and ASINs automatically.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-region-card-top"
  }, [_c('span', {
    staticClass: "sk-region-flag"
  }, [_vm._v("🌎")]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-info"
  }, [_c('div', {
    staticClass: "sk-region-name"
  }, [_vm._v("Americas")]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-countries"
  }, [_vm._v("US, Canada, Mexico, Brazil")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-region-card-top"
  }, [_c('span', {
    staticClass: "sk-region-flag"
  }, [_vm._v("🇪🇺")]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-info"
  }, [_c('div', {
    staticClass: "sk-region-name"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-countries"
  }, [_vm._v("UK, Germany, France, Spain, Italy, Netherlands, Belgium, Sweden, Poland, South Africa")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-region-card-top"
  }, [_c('span', {
    staticClass: "sk-region-flag"
  }, [_vm._v("🌐")]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-info"
  }, [_c('div', {
    staticClass: "sk-region-name"
  }, [_vm._v("Middle East")]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-countries"
  }, [_vm._v("UAE, Saudi Arabia, Egypt, Turkey")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-region-card-top"
  }, [_c('span', {
    staticClass: "sk-region-flag"
  }, [_vm._v("🇮🇳")]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-info"
  }, [_c('div', {
    staticClass: "sk-region-name"
  }, [_vm._v("India")]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-countries"
  }, [_vm._v("Amazon.in")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-region-card-top"
  }, [_c('span', {
    staticClass: "sk-region-flag"
  }, [_vm._v("🌏")]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-info"
  }, [_c('div', {
    staticClass: "sk-region-name"
  }, [_vm._v("Asia Pacific")]), _vm._v(" "), _c('div', {
    staticClass: "sk-region-countries"
  }, [_vm._v("Japan, Australia, Singapore")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e06ca1a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AmazonRegionConnect.vue
// module id = 788
// module chunks = 2